"use client";

import { useEffect } from "react";

import { useSession } from "next-auth/react";

import { EventKeys } from "./catalog";
import { EventPublisher } from "./events";

export function ObservabilityLayoutIntegration({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: session, status } = useSession();

  useEffect(() => {
    // Track page load via Stratum
    void EventPublisher.publishEvent(EventKeys.APP_LOADED, {
      event: "app_loaded",
      timestamp: new Date().toISOString(),
      url: window.location.href,
      user_agent: navigator.userAgent,
    });
  }, []);

  useEffect(() => {
    if (status === "authenticated" && session?.user) {
      // Identify user when authenticated via Stratum
      void EventPublisher.publishEvent(EventKeys.AUTH_IDENTIFY_USER, {
        distinct_id: session.user.id || session.user.email,
        eventType: "identify",
        person_properties: {
          email: session.user.email,
          name: `${session.user.firstName} ${session.user.lastName}`,
        },
      });
    } else if (status === "unauthenticated") {
      // Track user logout via Stratum
      void EventPublisher.publishEvent(EventKeys.USER_LOGGED_OUT, {
        event: "user_logged_out",
        timestamp: new Date().toISOString(),
      });
    }
  }, [status, session]);

  return <>{children}</>;
}
